/* import __COLOCATED_TEMPLATE__ from './posting-create-direct-review.hbs'; */
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { LSG_REVIEW_STARS__STAR_LABELS } from "../lsg/lsg-reviews-stars";

const CLASS_NAME = 'SH-c-posting-create-direct-review';

/**
 * This is the component to allow the buyer leave a review for a buyer during the direct hire posting creation workflow
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: '',
  CLASS_NAME,

  /**
   * Register services
   */
  errorTracker: service('error-tracker'),
  state: service('states/routes/posting-create'),
  stateManager: service('state-managers/routes/posting-create'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}    True when the form elements should be disabled
   */
  _areFormElementsDisabled: readOnly('state.isCreatePostingRequestInFlight'),

  /**
   * @type {User|null}  Direct hire user we're hiring
   */
  _freelancerUser: readOnly('state.updatedDirectFreelancerUser'),

  /**
   * @type {Array<String>}    List of strings we will send the to stars component to show when buyer selects a review rating.
   */
  _ratingTextLabels: LSG_REVIEW_STARS__STAR_LABELS,

  /**
   * @type {Number}     The star count that the user has clicked and given a review.
   */
  _updateReviewStarCount: readOnly('state.updatedDirectReviewStarCount'),

  actions: {
    /**
     * Handle when user clicks on a start to set a rating.
     *
     * @param {Number} starIndex
     */
    onStarClick: function(starIndex) {
      this.set('state.errors', {
        ...this.state.errors,
        review_score: undefined,
      });

      this.get('stateManager').updateReviewStarCount(starIndex + 1);
    },

    handleDirectReviewCommentInput: function(text) {
      this.set('state.errors', {
        ...this.state.errors,
        review_comment: undefined,
      });

      this.stateManager.updateDirectReviewComment(text);
    },
  }
});
